import React from 'react';
import { useIntl } from 'react-intl';
import styles from './index.module.less';
import { useLocale } from '../../utils/i18n';

const Footer = (props) => {
  const { style } = props;
  const intl = useIntl();
  const [locale] = useLocale();

  return (
    <div style={style}>
      <div className={styles.wrapper}>
        {/* <div className={styles.links}>
          <a
            className={styles.link}
            href={`https://privacy.mi.com/trust#/?locale=${
              locale.split('-')[0]
            }`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage({ id: 'Mi.Trust.Center' })}
          </a>
          <span className={styles.divider}>|</span>
          <a
            className={styles.link}
            href="https://sec.xiaomi.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage({ id: 'Mi.Security' })}
          </a>
          <span className={styles.divider}>|</span>
          <a
            className={styles.link}
            href={`https://privacy.mi.com/all/${locale === 'en' ? 'en_US' : locale.replace(/-([a-z]+)$/, (_, s) => `_${s.toUpperCase()}`)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {intl.formatMessage({ id: 'Privacy.Policy' })}
          </a>
        </div> */}
        <div className={styles.copyright}>
          {intl.formatMessage({ id: 'Rights' })} &nbsp;
          <a
          className={styles.privacyLink}
          href={`https://privacy.mi.com/all/${locale === 'en' ? 'en_US' : locale.replace(/-([a-z]+)$/, (_, s) => `_${s.toUpperCase()}`)}`}
          target="_blank"
          rel="noopener noreferrer">
            {locale === 'en'? 'Privacy Policy' :'小米隐私政策'}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
